import { Component } from '@headless-workspace/typings';

export const GridSection: Component = () => {
    return (
        <section id={'product-list-grid'} className={'px-1'}>
            <div className={'min-h-[1000px] bg-background-skeleton'}>Grid results</div>
        </section>
    );
};
